import TaskRegular from '../models/tasks/TaskRegular';
import TaskSingle from '../models/tasks/TaskSingle';
import { getDatesByFrequency, formatDate, isDateInRange, compareTasksByDate, toLocalMidnight } from './utils';
import { IS_SINGLE, WILL_BE_REMOVED, WILL_BE_CREATED } from '../constants/tasks';
import TaskGlobal from '../models/tasks/TaskGlobal';
import { TASKS_DELAYED, TASKS_GLOBAL, TASKS_REGULAR, TASKS_SINGLE } from '../constants/server';
import TaskDelayed from '../models/tasks/TaskDelayed';

export const getSingleTasksFromRegular = (task = new TaskRegular()) => {
  const dates = getDatesByFrequency(task.startDate, task.endDate, task.frequency, task.intervalName, task.intervalValue);
  return dates.map((date) => {
    return new TaskSingle({
      regularTaskId: task.id,
      globalTaskId: task.globalTaskId,

      type: IS_SINGLE,

      title: task.title,
      subtitle: task.title,
      description: task.description,
      note: task.note,

      date: formatDate(date),
      timeNeed: task.timeNeed,

      importance: task.importance,
      done: task.done,
    });
  });
};

export const getTasksInDay = (tasks = [], startMonth = new Date(), endMonth = new Date()) => {
  const tasksInDay = {};
  tasks.forEach((task) => {
    if (!isDateInRange(task.date || task.endDate, startMonth, endMonth)) {
      return;
    }
    const day = new Date(toLocalMidnight(task.date || task.endDate)).getDate();
    if (tasksInDay[day]) {
      tasksInDay[day] += 1;
    } else {
      tasksInDay[day] = 1;
    }
  });
  return tasksInDay;
};

export const getSingleTasksWithTempLabels = (regTask, singleTasksInit) => {
  const singleTasksNew = getSingleTasksFromRegular(regTask);

  const onlyNew = singleTasksNew.filter(compareTasksByDate(singleTasksInit)).map((task) => {
    return { ...task, tempLabel: WILL_BE_CREATED };
  });
  const onlyInit = singleTasksInit.filter(compareTasksByDate(singleTasksNew)).map((task) => {
    return { ...task, tempLabel: WILL_BE_REMOVED };
  });
  const onlyInitNotRemoved = singleTasksInit.filter(compareTasksByDate(onlyInit)).map((task) => {
    return { ...task, tempLabel: '' };
  });

  const allTasksInRegTask = [...onlyNew, ...onlyInit, ...onlyInitNotRemoved];

  return {
    allTasksInRegTask,
    onlyNew,
    onlyInit,
    onlyInitNotRemoved,
  };
};

export const getSingleTasksForUpdate = (allTasksInRegTask, singleTasksAdded, singleTasksRemoved) => {
  return allTasksInRegTask.filter(compareTasksByDate([...singleTasksAdded, ...singleTasksRemoved]));
};

export const checkDisableTasksDone = (disableTasksDone = false, tasks = []) => {
  return disableTasksDone
    ? tasks.filter((t) => {
      return !t.done;
    })
    : tasks;
};

export const convertTasksStructure = (tasksStructure) => {
  const tasksGlobal = (tasksStructure && tasksStructure[TASKS_GLOBAL]) || [];
  const tasksRegular = (tasksStructure && tasksStructure[TASKS_REGULAR]) || [];
  const tasksSingle = (tasksStructure && tasksStructure[TASKS_SINGLE]) || [];
  const tasksDelayed = (tasksStructure && tasksStructure[TASKS_DELAYED]) || [];

  return [
    ...tasksGlobal.map((task) => {
      let trg = [];
      let tsg = [];
      if (task.tasksRegular && Array.isArray(task.tasksRegular)) {
        trg = task.tasksRegular.map((tr) => {
          let tsr = [];
          if (tr.tasksSingle && Array.isArray(tr.tasksSingle)) {
            tsr = tr.tasksSingle.map((ts) => {
              return new TaskSingle().getTaskSingle(ts);
            });
          }
          return new TaskRegular().getTaskRegular({ ...tr, tasksSingle: tsr });
        });
      }
      if (task.tasksSingle && Array.isArray(task.tasksSingle)) {
        tsg = task.tasksSingle.map((ts) => {
          return new TaskSingle().getTaskSingle(ts);
        });
      }
      return new TaskGlobal().getTaskGlobal({
        ...task,
        tasksRegular: trg,
        tasksSingle: tsg,
      });
    }),
    ...tasksRegular.map((task) => {
      let tgr = null;
      let tsr = [];
      if (task.taskGlobal) {
        tgr = new TaskGlobal().getTaskGlobal(task.taskGlobal);
      }
      if (task.tasksSingle && Array.isArray(task.tasksSingle)) {
        tsr = task.tasksSingle.map((ts) => {
          return new TaskSingle().getTaskSingle(ts);
        });
      }
      return new TaskRegular().getTaskRegular({
        ...task,
        taskGlobal: tgr,
        tasksSingle: tsr,
      });
    }),
    ...tasksSingle.map((task) => {
      let tgs = null;
      let trs = null;
      if (task.taskGlobal) {
        tgs = new TaskGlobal().getTaskGlobal(task.taskGlobal);
      }
      if (task.taskRegular) {
        trs = new TaskRegular().getTaskRegular(task.taskRegular);
      }
      return new TaskSingle().getTaskSingle({
        ...task,
        taskGlobal: tgs,
        taskRegular: trs,
      });
    }),
    ...tasksDelayed.map((task) => {
      return new TaskDelayed().getTaskDelayed(task);
    }),
  ];
};

export const getSingleTasksOfGlobalDeep = (tasksRegular = [], tasksSingle = []) => {
  const tasksRegularTasksSingle = [];
  tasksRegular.forEach((taskRegular) => {
    tasksRegularTasksSingle.push(...taskRegular.tasksSingle);
  });

  return [...tasksSingle, ...tasksRegularTasksSingle];
};
